import * as Api from '@ViewModels';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import donorPerfectLogo from '../../../assets/logo_donorperfect.png';
import { ApiKeyIntegrationPage } from '../ApiKeyIntegrationPage';

export function DonorPerfectV2() {
	const userSession = useUserSession();

	return (
		<ApiKeyIntegrationPage
			provider={Api.IntegrationProvider.DonorPerfect}
			integrationType={Api.ExternalIntegrationType.DonorPerfect}
			displayName='DonorPerfect'
			logo={donorPerfectLogo}
			logoAlt='DonorPerfect Logo'
			description='Levitate can sync with DonorPerfect to pull donor information, including names, email and physical mailing addresses, phone numbers, gifting history, and more.'
			credentialLabel='API Key'
			credentialNoun='API key'
			connectPrompt='To get started, enter the API key provided by DonorPerfect Support or their API Help Desk.'
			manageConnectedText='Your DonorPerfect donors will show up in the contacts tab, and their gifts on the donations dashboard.'
			manageNotConnectedText='Once you are configured, your DonorPerfect donors will show up in the contacts tab.'
			disconnectTitle='Disconnect DonorPerfect? Levitate will stop syncing donor data from your DonorPerfect account. You can reconnect at any time by entering your API key again.'
			onConnected={() => {
				// While impersonating, the pending actions on this session belong to the admin, not the account being
				// configured, so clearing one here would dismiss the wrong dashboard card.
				if (!userSession.impersonationContext?.account?.id) {
					userSession.resolvePendingAction(Api.PendingActions.ConnectDonorPerfectV2);
				}
			}}
		/>
	);
}
